import React, { useEffect } from "react";
import { Box, Typography, Container, Grid, Button, Link } from "@mui/material";
import { motion } from "framer-motion";
import heroBg from "../../assets/nextix/business-digital-banner.jpg";
import cityWideWhitepaper from '../../City-wide-whitepaper.pdf';
import globalVideoWhitepaper from '../../Global-Video-whitepaper.pdf';
import ipPhonesWhitepaper from '../../IP-Phones.pdf';
import ofwContactCenterWhitepaper from '../../OFW-Contact-Center.pdf';

const DigitalInfrastructureScreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box sx={{ backgroundColor: "#fff" }}>
            {/* BANNER IMAGE - Full image display in container */}
            <Container maxWidth="lg" sx={{ pt: 12, pb: 4 }}>
                <Box sx={{
                    borderRadius: "8px",
                    overflow: "hidden"
                }}>
                    <img
                        src={heroBg}
                        alt="Digital Infrastructure - scalable solutions"
                        style={{
                            width: "100%",
                            height: "auto",
                            display: "block"
                        }}
                    />
                </Box>
            </Container>

            {/* MAIN CONTENT */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Grid container spacing={{ xs: 2, md: 6 }}>
                    {/* Left Column - Main Content */}
                    <Grid item xs={12} md={8}>
                        {/* Main Digital Infrastructure Section */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Digital Infrastructure
                            </Typography>
                        </motion.div>

                        {/* Call center system */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.1 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Call center system
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 2, textAlign: "start" }}>
                                Nextix Unified Contact Center enables you to easily connect with your customers using cutting edge call center technology, improve agent efficiency, and maximize value for your business and relationship with your clients.
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                For more than 10 years now, nextix has delivered unmatched performance and productivity for contact centers around the globe. nextix offers premise or hosted based scalable call center solutions to meet the ever changing demands of call centers. nextix solutions are enabled by industry experts to address the real problems of everyday call center operations. The result is the most flexible, innovative, and agile call center system fit for you business needs, we help companies maximize call center performance and increase business profitability.
                            </Typography>
                        </motion.div>

                        {/* Enterprise IPPBX */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Enterprise IPPBX
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Nextix delivers IPPBX unified communication by merging voice and data networks allowing users to communicate seamlessly. The nextix IPPBX Enterprise System is capable of integrating computer intelligence to any telephone, thus allowing it to have infinite capabilities. The same interface also equips users real-time presence management controls, corporate and workgroup directories and conferencing.
                            </Typography>
                        </motion.div>

                        {/* Workstation as a Service */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Workstation as a Service
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Workspace as a Service (WaaS) is a platform that provides end-to-end digital hardware, software and infrastructure that can be designed according to clients’ needs and requirements with options for Build-out, Upgrade, Leasing and Back-up. Nextix supports and maintains the infrastructure – with available mobile application The focus is to manage all digital hardware, software and infrastructure components needed for companies to effectively service their clients. Nextix partners with clients for the right, effective and scalable solutions at the client’s preferred location anywhere in the Philippines.
                            </Typography>
                        </motion.div>

                        {/* Data Center solutions */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Data Center solutions
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Nextix is geared towards building, running, maintaining and improving your next generation infrastructure in alignment with your business needs with faster ROI without sacrificing speed, quality and security. We deliver IT in such a way that enables today’s business practices as well as those of the future. Nextix accelerates innovation in IT infrastructure to create more value for our clients. We leverage technology by collaborating with strategic partners, utilizing deep industry vertical expertise and delivering on a global scale. We are leading the future for IT infrastructure.
                            </Typography>
                        </motion.div>

                        {/* Managed IT service support */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.5 }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#375ca8", textAlign: "start" }}>
                                Managed IT service support
                            </Typography>
                            <Typography paragraph sx={{ color: "#666", lineHeight: 1.8, mb: 4, textAlign: "start" }}>
                                Nextix IT Service Support encompasses the support processes necessary to ensure service quality. We manage problems and change in your IT Infrastructure.
                            </Typography>
                        </motion.div>

                    </Grid>

                    {/* Right Column - Sidebar */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ position: { md: "sticky" }, top: 100, textAlign: 'start' }}>
                            {/* Send Us A Message */}
                            <motion.div
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6 }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: "#375ca8" }}>
                                    Send Us A Message
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 3, color: "#666", lineHeight: 1.6 }}>
                                    For more inquiries about our Products, send us a message
                                </Typography>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    href="mailto:info@nextix.co"
                                    sx={{
                                        backgroundColor: "#82c9ed",
                                        color: "white",
                                        fontWeight: 700,
                                        py: 1.5,
                                        mb: 4,
                                        "&:hover": { backgroundColor: "#6bb5d9" }
                                    }}
                                >
                                    CONTACT OUR SALES NOW
                                </Button>
                            </motion.div>

                            {/* Contact Information */}
                            <motion.div
                                initial={{ opacity: 0, x: 30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.1 }}
                            >
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: "#1c1c1c" }}>
                                    Email Us:
                                </Typography>

                                <Box sx={{ mb: 2 }}>
                                    <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                                        <strong>Inquiry:</strong>{" "}
                                        <Link href="mailto:info@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                            info@nextix.co
                                        </Link>
                                    </Typography>
                                </Box>

                                <Box sx={{ mb: 2 }}>
                                    <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                                        <strong>Support:</strong>{" "}
                                        <Link href="mailto:helpdesk@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                            helpdesk@nextix.co
                                        </Link>
                                    </Typography>
                                </Box>

                                <Box sx={{ mb: 4 }}>
                                    <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                                        <strong>Privacy:</strong>{" "}
                                        <Link href="mailto:dpo@nextix.co" sx={{ color: "#375ca8", textDecoration: "none" }}>
                                            dpo@nextix.co
                                        </Link>
                                    </Typography>
                                </Box>

                                {/* White Paper Resources */}
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2, color: "#1c1c1c" }}>
                                    White Paper
                                </Typography>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                    import cityWideWhitepaper from '../../City-wide-whitepaper.pdf';
                                    import globalVideoWhitepaper from '../../Global-Video-whitepaper.pdf';
                                    import ipPhonesWhitepaper from '../../IP-Phones.pdf';
                                    import ofwContactCenterWhitepaper from '../../OFW-Contact-Center.pdf';

                                    // ...
                                    <Link href={ofwContactCenterWhitepaper} target="_blank" rel="noopener noreferrer" sx={{ color: "#375ca8", textDecoration: "none", fontSize: "0.875rem", "&:hover": { textDecoration: "none", color: '#5bc0de' } }}>
                                        OFW-Contact-Center
                                    </Link>
                                    <Link href={globalVideoWhitepaper} target="_blank" rel="noopener noreferrer" sx={{ color: "#375ca8", textDecoration: "none", fontSize: "0.875rem", "&:hover": { textDecoration: "none", color: '#5bc0de' } }}>
                                        Global-Video-whitepaper
                                    </Link>
                                    <Link href={cityWideWhitepaper} target="_blank" rel="noopener noreferrer" sx={{ color: "#375ca8", textDecoration: "none", fontSize: "0.875rem", "&:hover": { textDecoration: "none", color: '#5bc0de' } }}>
                                        City-wide-whitepaper
                                    </Link>
                                    {/* <Link href={ipPhonesWhitepaper} target="_blank" rel="noopener noreferrer" sx={{ color: "#375ca8", textDecoration: "none", fontSize: "0.875rem", "&:hover": { textDecoration: "none", color: '#5bc0de' } }}>
                                        IP-Phones
                                    </Link> */}
                                </Box>
                            </motion.div>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default DigitalInfrastructureScreen;
